module.exports = __webpack_public_path__ + "img/order_notice@2x.18087869.png";